<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<h1 class="half">GILDED</h1>
<a id="page_iv"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Halftitle.vue?48f64b0b